import { useTranslation } from 'react-i18next'
import { Group } from '../types/models'
import { DataTable, DataTableColumns } from './atoms/DataTable'
import { ChangeEvent, useLayoutEffect, useState } from 'react'
import { Box } from '@mui/system'
import { PageTitle } from './atoms/PageTitle'
import { TextField } from '@mui/material'

export interface GroupDataTableProps {
  groups: Group[]
  openUserGroupModal: boolean
  setOpenUserGroupModal: (state: boolean) => void
}

export function GroupDataTable(props: GroupDataTableProps): React.ReactElement {

  const { groups } = props
  const { t } = useTranslation()
  const [renderedGroups, setRenderGroups] = useState<Group[]>(groups)

  useLayoutEffect(() => {
    setRenderGroups(groups)
  }, [groups])

  const columnsGroups: DataTableColumns<Group> = {
    [t('Column-ID')]: 'id',
    [t('Column-Name')]: 'name',
  }

  const handleSearchGroup = (event: ChangeEvent<HTMLInputElement>) => {
    const searchValue = event.target.value.trim().toLowerCase()
    const filteredGroups = groups.filter((group) => group.name.toLowerCase().includes(searchValue))
    setRenderGroups(filteredGroups)
  }

  return (
    <Box>
      <>
        <Box sx={{ mt: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <PageTitle title={t('Groups')}/>
            <TextField
              sx={{ '& ::placeholder': { fontSize: '14px' }, mb: 2 }}
              margin="normal"
              name="group-search-bar"
              placeholder={t('Search by name')}
              type="search"
              id='group-search-bar'
              size="small"
              onChange={handleSearchGroup}
            />
          </Box>
          <Box sx={{ mt: 2, mb: 4, position: 'relative' }}>
            <DataTable data={renderedGroups} columns={columnsGroups} link="/admin/user-groups/:id"/>
          </Box>
        </Box>
      </>
    </Box>
  )
}
